import { CssBaseline } from '@mui/material';
import { ReactNode } from 'react';
import { useLocation } from 'react-router';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import * as React from 'react';
import { Spinner } from '@ankr.com/ui';

import { AccountProvider } from 'modules/account/components/AccountProvider';
import { Dialogs } from 'modules/guardDialog';
import { ReferralProgramsProvider } from 'modules/strapi/components/ReferralProgramsProvider';
import { SentryErrorBoundary } from 'modules/common/components/SentryErrorBoundary';
import { isSSG } from 'modules/common/utils/isSSG';
import { useMetatags } from 'uiKit/utils/metatags';
import { useInitializeLocale } from 'modules/i18n/hooks/useInitializeLocale';

import { MaintenanceDialogContainer } from './components/MaintenanceDialogContainer';
import { ReferralFlowContainer } from './components/ReferralFlowContainer';
import { ThemeProviderContainer } from './components/ThemeProviderContainer';

interface IAppBaseProps {
  children: ReactNode;
}
const cache = createCache({
  key: 'mui-css',
  container: document.head,
  prepend: true,
  speedy: !isSSG(),
});

export const AppBase = ({ children }: IAppBaseProps) => {
  const location = useLocation();

  const isInitialized = useInitializeLocale();

  useMetatags(location.pathname);

  return (
    <CacheProvider value={cache}>
      <ThemeProviderContainer>
        <CssBaseline />
        <AccountProvider>
          <SentryErrorBoundary>
            {isInitialized ? (
              <>
                {children}
                <ReferralProgramsProvider>
                  <ReferralFlowContainer />
                </ReferralProgramsProvider>
                <Dialogs />
                <MaintenanceDialogContainer />
              </>
            ) : (
              <Spinner />
            )}
          </SentryErrorBoundary>
        </AccountProvider>
      </ThemeProviderContainer>
    </CacheProvider>
  );
};
